import React from "react";
import ReactDOM from "react-dom";

export const debugSSR = false;

export const renderOrHydrate = <P extends any>(
  reactElement: React.ReactElement<P>,
  element: Element,
  isInitialRender: boolean,
) => {
  ReactDOM.render(reactElement, element);
};
